import React, { useCallback, useEffect, useState } from 'react';
import {
  Box, Button, FormControl, Input, InputLabel, MenuItem, Select, Typography
} from '@mui/material';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useUserCore } from '../../../core/modules/user';
import { useGlobalCore } from '../../../core/modules/global';
import { CREATE_USER_DIALOG } from '../../../core/constants/dialog';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { CompanyRole } from '../../../core/modules/user/interfaces/role';


const Header = () => {
  const { t } = useTranslation();
  const { users, setOptions } = useUserCore();
  const { openDialog } = useGlobalCore();

  const [searchTxt, setSearchTxt] = useState<string>('');
  const [active, setActive] = useState<string>('active');
  const [role, setRole] = useState<string>('all');
  const debouncedOnChange = debounce((value: string) => setSearchTxt(value), 500);

  useEffect(() => {
    setOptions({
      text: searchTxt,
      active: active === 'all' ? null : active === 'active',
      role: role === 'all' ? null : role, // Pasamos el valor del string directamente
    });
  }, [searchTxt, active, role, setOptions]);

  const openingDialog = useCallback(() => {
    openDialog(CREATE_USER_DIALOG);
  }, [openDialog]);

  return (
    <div className="p-24 sm:p-32 w-full border-b bg-white">
      <div className="flex flex-col sm:flex-row justify-between items-center">
        <div>
          <Typography className="text-2xl md:text-3xl font-extrabold tracking-tight">
            {t('users.title')}
          </Typography>
          <Typography className="text-sm font-medium" color="text.secondary">
            {users.length} {t('users.label.users')}
          </Typography>
        </div>
        <Button
          className="mt-4 sm:mt-0"
          variant="contained"
          color="secondary"
          startIcon={<AddCircleOutlineOutlinedIcon />}
          onClick={openingDialog}
        >
          Crear Usuario
        </Button>
      </div>
      <div className="flex flex-col sm:flex-row gap-4 flex-1 items-center mt-6">
        <Box className="flex flex-1 w-full sm:w-auto items-center px-4 border rounded-full">
          <SearchOutlinedIcon color="action" />
          <Input
            placeholder={t('users.placeholder.search')}
            className="flex flex-1 px-4"
            disableUnderline
            fullWidth
            onChange={(e) => debouncedOnChange(e.target.value)}
          />
        </Box>
        <div className="flex flex-row items-center gap-4 w-full sm:w-auto">
          {/* --- 2. ACTUALIZAR EL SELECT DE ROLES --- */}
          <FormControl className="w-1/2 sm:w-auto" variant="outlined" size="small" fullWidth>
            <InputLabel id="user-role-label">{t('label.role')}</InputLabel>
            <Select
              labelId="user-role-label"
              value={role}
              label={t('label.role')}
              onChange={(e) => setRole(e.target.value)}
            >
              <MenuItem value="all">{t('select.option.all')}</MenuItem>
              <MenuItem value="superuser">Super Admin</MenuItem>
              <MenuItem value={CompanyRole.COMPANY_ADMIN}>{CompanyRole.COMPANY_ADMIN}</MenuItem>
              <MenuItem value={CompanyRole.USER}>{CompanyRole.USER}</MenuItem>
              <MenuItem value={CompanyRole.TOMADOR_INVENTARIO}>{CompanyRole.TOMADOR_INVENTARIO}</MenuItem>
            </Select>
          </FormControl>
          
          <FormControl className="w-1/2 sm:w-auto" variant="outlined" size="small" fullWidth>
            <InputLabel id="user-status-label">{t('label.status')}</InputLabel>
            <Select
              labelId="user-status-label"
              value={active}
              label={t('label.status')}
              onChange={(e) => setActive(e.target.value)}
            >
              <MenuItem value="all">{t('select.option.all')}</MenuItem>
              <MenuItem value="active">{t('select.option.active')}</MenuItem>
              <MenuItem value="inactive">{t('select.option.inactive')}</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  );
};

export default Header;